import React from "react";
import { useSelector } from "react-redux";
import { selectCurrentUserAttributes } from "slices/authSlice";
import {
  MY_BOARD,
  selectMePinnedShare,
  selectMeShout,
  selectMyLuid,
  selectSpaceLayoutValue,
} from "slices/spaceMediaSlice";
import Board from "../../Board/Board";
const MyBoard = () => {
  const myLuid = useSelector(selectMyLuid);
  const meAttr = useSelector(selectCurrentUserAttributes);
  const meShout = useSelector(selectMeShout);
  const mePinnedShare = useSelector(selectMePinnedShare);
  const spaceLayout = useSelector(selectSpaceLayoutValue);

  return (
    <div
      className={`board-container mine ${
        meShout || mePinnedShare ? "shouting-board" : ""
      }`}
      style={{ display: spaceLayout === MY_BOARD ? "" : "none" }}
    >
      <Board luid={myLuid} person={meAttr} local />
    </div>
  );
};

export default MyBoard;
